module.exports = __webpack_public_path__ + "img/girl-tattoo.143ca055.png";